export { RotateCCWIcon } from './rotate-ccw'
